var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({attrs:{"text":"","x-small":""},on:{"click":_vm.clearNote}},on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-restart")])],1)]}}])},[_c('span',[_vm._v(" Start Over ")]),_c('confirm-modal',{ref:"confirm"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }